/** 与 nav 叶子路径一一对应；用于占位页标题与可选行业参考外链 */
export const industrySolutionPageMeta: Record<
  string,
  { titleKey: string; referenceUrl?: string }
> = {
  '/solutions/new-energy/solar-storage': {
    titleKey: 'nav.solutions.newEnergy.solar',
    referenceUrl: 'https://www.solaxpower.com/',
  },
  '/solutions/new-energy/home-storage': {
    titleKey: 'nav.solutions.newEnergy.storage',
    referenceUrl: 'https://en.goodwe.com/',
  },
  '/solutions/new-energy/portable': {
    titleKey: 'nav.solutions.newEnergy.portable',
    referenceUrl: 'https://www.ecoflow.com/us',
  },
  '/solutions/new-energy/charging-pile': {
    titleKey: 'nav.solutions.newEnergy.charging',
    referenceUrl: 'https://autelenergy.com/',
  },
  '/solutions/new-energy/pool-cleaner': {
    titleKey: 'nav.solutions.newEnergy.pool',
    referenceUrl: 'https://aiper.com/us/home',
  },
  '/solutions/robot/pool-cleaner': {
    titleKey: 'nav.solutions.robot.poolCleaner',
    referenceUrl: 'https://aiper.com/us/home',
  },
  '/solutions/robot/mower': {
    titleKey: 'nav.solutions.robot.mower',
    referenceUrl: 'https://us.mammotion.com/',
  },
  '/solutions/robot/embodied': {
    titleKey: 'nav.solutions.robot.embodied',
    referenceUrl: 'https://www.switch-bot.com/',
  },
  '/solutions/robot/commercial': {
    titleKey: 'nav.solutions.robot.commercial',
    referenceUrl: 'https://en.orionstar.com/',
  },
  '/solutions/ai-hardware/recorder': {
    titleKey: 'nav.solutions.aiHardware.recorder',
    referenceUrl: 'https://www.plaud.ai/',
  },
  '/solutions/ai-hardware/ai-glasses': {
    titleKey: 'nav.solutions.aiHardware.aiGlasses',
    referenceUrl: 'https://www.evenrealities.com/',
  },
  '/solutions/ai-hardware/wearable': {
    titleKey: 'nav.solutions.aiHardware.wearable',
    referenceUrl: 'https://www.suunto.com/en-us/',
  },
  '/solutions/diy-tools/3d-printer': {
    titleKey: 'nav.solutions.diyTools.printer3d',
    referenceUrl: 'https://bambulab.com/en-us',
  },
  '/solutions/diy-tools/laser': {
    titleKey: 'nav.solutions.diyTools.laser',
    referenceUrl: 'https://www.xtool.com/',
  },
  '/solutions/diy-tools/cnc': {
    titleKey: 'nav.solutions.diyTools.cnc',
    referenceUrl: 'https://www.makera.com/',
  },
  '/solutions/mobility/scooter': {
    titleKey: 'nav.solutions.mobility.scooter',
    referenceUrl: 'https://shop.segway.com/nl_en/',
  },
  '/solutions/mobility/elderly': {
    titleKey: 'nav.solutions.mobility.elderly',
    referenceUrl: 'https://www.paiseec.com/',
  },
  '/solutions/security/ipc': {
    titleKey: 'nav.solutions.security.ipc',
    referenceUrl: 'https://www.blurams.com/',
  },
  '/solutions/security/bird-feeder': {
    titleKey: 'nav.solutions.security.birdFeeder',
    referenceUrl: 'https://www.birdfy.com/',
  },
  '/solutions/security/hunting-camera': {
    titleKey: 'nav.solutions.security.huntingCamera',
    referenceUrl: 'https://www.hikmicrotech.com/en/',
  },
  '/solutions/appliances/water-purifier': {
    titleKey: 'nav.solutions.appliances.waterPurifier',
    referenceUrl: 'https://ecopure.com/',
  },
  '/solutions/appliances/ice-maker': {
    titleKey: 'nav.solutions.appliances.iceMaker',
    referenceUrl: 'https://www.euhomy.com/',
  },
  '/solutions/fitness/speediance': {
    titleKey: 'nav.solutions.fitness.speediance',
    referenceUrl: 'https://www.speediance.com/',
  },
  '/solutions/pet/smart-life': {
    titleKey: 'nav.solutions.pet.smartLife',
    referenceUrl: 'https://www.catlinkus.com/',
  },
  '/solutions/furniture/lift-desk': {
    titleKey: 'nav.solutions.furniture.liftDesk',
    referenceUrl: 'https://www.fezibo.com/',
  },
  '/solutions/display/outdoor': {
    titleKey: 'nav.solutions.display.outdoor',
    referenceUrl: 'https://www.kontechgroup.com/',
  },
  '/solutions/display/portable-screen': {
    titleKey: 'nav.solutions.display.portableScreen',
    referenceUrl: 'https://www.fopodisplay.com/',
  },
};

export const industrySolutionPaths = Object.keys(industrySolutionPageMeta);
